module.exports = __webpack_public_path__ + "media/images/about-us/media5-831dd11394ce3fd1c12d08dc5927f552.png";